// extracted by mini-css-extract-plugin
export default {"addOnsLoading":"AddOnsSection_addOnsLoading__XwDbz"};